<script>
import axios from 'axios'
import moment from 'moment/moment'
import ExecutionActivityDetail from '@/components/execution/ExecutionActivityDetail.vue'

const _ = require('lodash')
export default {
  name: 'ExecutionActivities',
  components: { ExecutionActivityDetail },
  computed: {
    moment() {
      return moment
    }
  },

  props: {
    execution: {
      type: Object,
      required: true
    },
    selectedActivityId: {
      type: String,
      required: false
    }
  },
  data: () => ({
    headerActivity: [
      {
        text: 'Activity Id',
        align: 'left',
        value: 'hexId',
        sortable: false
      },
      {
        text: 'Activity Type / Execution Id',
        value: 'activityType',
        sortable: false
      },
      {
        text: 'Workflow Activity Name',
        value: 'camundaProperties.currentActivityId',
        sortable: false
      },
      { text: 'Created At', value: 'createdAt' },
      { text: 'Go-to Bot', value: 'action', sortable: false }
    ],
    activities: [],
    activitiesLoading: false,
    searchActivities: '',
    pagination: {
      page: 1,
      rowsPerPage: 5,
      sortBy: 'createdAt',
      descending: false,
      totalItems: 0
    },
    current: {
      page: 1,
      rowsPerPage: 5,
      sortBy: 'createdAt',
      descending: false
    },
    rowsPerPageItems: [5, 10, 25]
  }),

  mounted() {
    this.getItems()
  },
  watch: {
    selectedActivityId() {
      this.getItems()
    },
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.current.page ||
            this.pagination.rowsPerPage !== this.current.rowsPerPage ||
            this.pagination.sortBy !== this.current.sortBy ||
            this.pagination.descending !== this.current.descending
          ) {
            this.current.page = this.pagination.page
            this.current.rowsPerPage = this.pagination.rowsPerPage
            this.current.sortBy = this.pagination.sortBy
            this.current.descending = this.pagination.descending
            this.getItems()
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      },
      deep: true
    }
  },
  methods: {
    format(input) {
      return _.capitalize(_.startCase(input))
    },
    clearAllFilters() {
      this.searchActivities = ''
      this.$emit('clearAllSelections')
    },
    getUrlParams() {
      let urlParams = ''
      //fill URL Params from current structure

      urlParams += `&page=${this.current.page}`
      urlParams += `&size=${this.current.rowsPerPage}`
      if (this.current.sortBy) {
        urlParams += `&sort=${this.current.sortBy}`
        if (this.current.descending) {
          urlParams += `,desc`
        }
      }
      if (this.searchActivities) {
        urlParams += `&activityType=${this.searchActivities}`
      }
      return urlParams
    },
    getItems() {
      this.activitiesLoading = true
      let url = '/api/v1/states/' + this.execution.state + '/stacks'

      if (this.selectedActivityId && this.selectedActivityId !== '') {
        url = url + '/activity/' + this.selectedActivityId
      }

      const urlParams = this.getUrlParams()

      url = url + '?' + urlParams

      axios
        .get(url)
        .then(response => {
          if (response.data._embedded) {
            this.pagination.totalItems = response.data.page.totalElements
            this.activities = response.data._embedded.stacks
          } else {
            this.pagination.totalItems = 0
            this.activities = []
          }
          this.activitiesLoading = false
        })
        .catch(error => {
          console.log(error)
          this.activitiesLoading = false
        })
    },
    goToBotView(activity) {
      this.$emit('goToBotExecution', activity.executionId)
    }
  }
}
</script>

<template>
  <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
    <v-card-title>
      <span class="body-1 beez-bold pl-3">Workflow Activities</span>
      <v-spacer />
      <!--      <v-list-tile-avatar>-->
      <!--        <v-icon>search</v-icon>-->
      <!--      </v-list-tile-avatar>-->
      <!--      <v-list-tile-content>-->
      <!--        <v-list-tile-sub-title>-->
      <!--          <v-text-field-->
      <!--            v-model="searchActivities"-->
      <!--            color="secondary"-->
      <!--            label="Search by Activity Type"-->
      <!--            xs5-->
      <!--          >-->
      <!--          </v-text-field>-->
      <!--        </v-list-tile-sub-title>-->
      <!--      </v-list-tile-content>-->
      <!--      <v-tooltip bottom>-->
      <!--        <v-btn slot="activator" flat icon @click="searchActivities = ''">-->
      <!--          <v-icon>clear</v-icon>-->
      <!--        </v-btn>-->
      <!--        <span>Clear search</span>-->
      <!--            </v-tooltip>-->
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="getItems()">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="clearAllFilters()">
          <v-icon>clear_all</v-icon>
        </v-btn>
        <span>Clear Selections</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headerActivity"
        :items="activities"
        :loading="activitiesLoading"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="pagination.totalItems"
        item-key="hexId"
      >
        <v-progress-linear slot="progress" color="accent" indeterminate />
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div class="body-1 font-weight-bold">
                <div v-if="props.item.camundaProperties">
                  {{ props.item.camundaProperties.currentActivityId }}
                </div>
              </div>
              <div class="caption">
                {{ props.item.hexId }}
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div class="body-1 font-weight-bold">
                {{ format(props.item.activityType) }}
              </div>
              <div class="caption" v-if="props.item.activityType === 'BOT'">
                {{ props.item.executionId }}
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div v-if="props.item.camundaProperties">
                <div class="body-1 font-weight-bold">
                  {{ props.item.camundaProperties.currentActivityName }}
                </div>
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{
                props.item.createdAt
                  ? moment(props.item.createdAt)
                      .utc()
                      .local()
                      .format('DD MMM YYYY hh:mm:ss a')
                  : ''
              }}
            </td>
            <td>
              <v-btn
                icon
                :disabled="props.item.activityType !== 'BOT'"
                @click="goToBotView(props.item)"
                :class="$vuetify.dark ? 'btn-dark ' : 'btn-light '"
              >
                <v-icon>link</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-flex>
            <template>
              <execution-activity-detail :activity="props.item" />
            </template>
          </v-flex>
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="warning" icon="warning">
            No Activities found!
          </v-alert>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
